import { Button } from 'app/components/common/Button';
import moment from 'moment';
import { useState } from 'react';

// PPTX-Folienformat in Zoll: 1280x800px bei 100px/Zoll => 16:10
const PPTX_WIDTH = 12.8;
const PPTX_HEIGHT = 8;

// Exportiert alle .usage-slide der Übersicht als PPTX (eine Folie = ein Screenshot).
// Läuft komplett im Browser — bewusst ohne den Print-Service (kein A4-Zwang, keine Fußzeilen).
// html-to-image und pptxgenjs werden erst beim Klick nachgeladen.
export const UsageExportButton = () => {
	const [exporting, setExporting] = useState(false);

	const exportPptx = async () => {
		setExporting(true);
		try {
			const [{ toPng }, { default: PptxGenJS }] = await Promise.all([import('html-to-image'), import('pptxgenjs')]);

			const slides = Array.from(document.querySelectorAll<HTMLElement>('.usage-report .usage-slide'));
			if (slides.length === 0) {
				return;
			}

			const pptx = new PptxGenJS();
			pptx.defineLayout({ name: 'DVS_16x10', width: PPTX_WIDTH, height: PPTX_HEIGHT });
			pptx.layout = 'DVS_16x10';

			for (const el of slides) {
				// pixelRatio 2 => 2560x1600 je Folie, ausreichend scharf für Beamer und Druck
				const png = await toPng(el, { pixelRatio: 2 });
				pptx.addSlide().addImage({ data: png, x: 0, y: 0, w: PPTX_WIDTH, h: PPTX_HEIGHT });
			}

			await pptx.writeFile({ fileName: `DVS_Quartalsbericht_Q${moment().quarter()}_${moment().year()}.pptx` });
		} finally {
			setExporting(false);
		}
	};

	return (
		<div className="usage-export-bar print-none">
			<Button className="button is-primary" onClick={exportPptx} disabled={exporting}>
				{exporting ? 'Exportiere...' : 'Als PPTX exportieren'}
			</Button>
		</div>
	);
};
